import { render, staticRenderFns } from "./Followuprecordscity.vue?vue&type=template&id=12964958&"
import script from "./Followuprecordscity.vue?vue&type=script&lang=js&"
export * from "./Followuprecordscity.vue?vue&type=script&lang=js&"
import style0 from "./Followuprecordscity.vue?vue&type=style&index=0&id=12964958&lang=css&"
import style1 from "./Followuprecordscity.vue?vue&type=style&index=1&id=12964958&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12964958')) {
      api.createRecord('12964958', component.options)
    } else {
      api.reload('12964958', component.options)
    }
    module.hot.accept("./Followuprecordscity.vue?vue&type=template&id=12964958&", function () {
      api.rerender('12964958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Followup/Followuprecordscity.vue"
export default component.exports